import React, { useState } from 'react';
import { IngredientCombinationType, Nutrients } from '~/src/types/Misc';
import { v4 as uuid } from 'uuid';
import { saveAs } from 'file-saver';

import { IngredientGetDto } from '~/src/types/ingredientGetDto';
import { calcValueOfPercentage } from '~/src/utils/misc';
import { DEFAULT_SERVINGS, DEFAULT_SERVING_SIZE } from '~/src/utils/constants';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import { StatusCodes } from 'http-status-codes';
import IngredientsApi from '~/src/services/api/IngredientsApi';
import styled from 'styled-components';

interface Props {
  target: IngredientGetDto;
}
export default function CombinationsTable({ target }: Props): JSX.Element {
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const downloadResults = async (): Promise<void> => {
    setIsExporting(true);
    const x = await IngredientsApi.export(target.id);

    if (x.status === StatusCodes.OK) {
      setIsExporting(false);
      const courseSheet = x.data;
      if (courseSheet) {
        const blob = new Blob([courseSheet], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        saveAs(blob, `export-ingredient.xlsx`);
      }
    }
    setIsExporting(false);
  };

  const totalWeight = (target.servingSize || DEFAULT_SERVING_SIZE) * (target.servings || DEFAULT_SERVINGS);
  return (
    <div style={{ marginTop: 18 }}>
      {target.errorScore && (
        <>
          <TableWrapper>
            <tbody>
              <tr>
                <th>{target.name}</th>
                <th>100.0%</th>
                <th>For Serving ({target.servingSize || DEFAULT_SERVING_SIZE})g</th>
                <th>Total ({totalWeight})g</th>
              </tr>
              {target.childIngredients?.map((ingr) => (
                <tr key={ingr.id}>
                  <td>{ingr.name}</td>
                  <td>{ingr.percentFromWhole}%</td>
                  <td>{ingr.percentFromWhole * ((target.servingSize || DEFAULT_SERVING_SIZE) / 100)}g</td>
                  <td>{calcValueOfPercentage(totalWeight, ingr.percentFromWhole)}</td>
                </tr>
              ))}
            </tbody>
          </TableWrapper>
          <b>Error: {target.errorScore}</b>
          <div>
            <ButtonComponent
              title="DownloadExcel"
              type="button"
              onClick={downloadResults}
              isSubmitting={isExporting}
            />
          </div>
        </>
      )}
    </div>
  );
}

const TableWrapper = styled.div`
  background: #f4f4f4;
  border-radius: 10px;
  padding: 40px 20px;
`;
